import { GatsbyImage, StaticImage, getImage } from 'gatsby-plugin-image'
import React, { useEffect, useState } from 'react'
// import Lottie from 'react-lottie'
import toCamelCase from '../../function/toCamelCaseString'
import ScrollDown from '../../Lotties/ScrollDown.json'
import Button from '../Button/Button'
// import parser from 'html-react-parser'
import * as headingStyle from './hero.module.css'

const HeroBlock = ({ heroBlock }) => {
    let [pageLoaded, setPageloaded] = useState(false)
    useEffect(() => {
        const onPageLoad = () => {
            let videoEl = document.querySelector('video') || null
            let source = videoEl ? videoEl.querySelector('source') : null
            if (source) {
                source.src = background?.videoBackground?.video
                // Load the video
                videoEl.load()
            }
            setPageloaded(true)
        }
        if (document.readyState === 'complete') {
            onPageLoad()
        } else {
            window.addEventListener('load', onPageLoad, false)
            return () => window.removeEventListener('load', onPageLoad)
        }
    }, [])
    if (!heroBlock) {
        return null
    }
    const { title, description, buttons, background } = heroBlock

    const styles = background?.solidColor
        ? background?.solidColor
        : !Object?.values(background?.gradientColor).includes(null)
        ? `linear-gradient(to right,${background?.gradientColor?.firstColor},${background?.gradientColor?.secondColor})`
        : '#2B0838'
    const scrollDown = () => {
        let pageHeight = window.innerHeight - 100
        window.scrollBy(0, pageHeight)
    }

    return (
        <div
            className="relative lg:h-screen md:h-[60vh] grid place-items-center mt-[-100px] lg:mt-0 xl:mb-[114x]"
            style={{ backgroundColor: '#2b0838' }}
        >
            {background?.videoBackground && (
                <video
                    autoPlay
                    loop
                    muted
                    poster={'/images/Fallback.webp'}
                    className="absolute h-full"
                >
                    <source
                        data-src={background?.videoBackground?.video}
                        type="video/mp4"
                    />
                </video>
            )}

            {background?.imageBackground && (
                <div className="absolute h-[122vh] w-auto max-w-[600px] -left-[199px] -top-[50px] md:max-w-none md:-top-[150px] lg:-left-[67%] lg:-top-[10%]">
                    {background?.imageBackground?.localFile ? (
                        <GatsbyImage
                            image={getImage(
                                background?.imageBackground?.localFile
                            )}
                            className="w-full h-full"
                            objectFit="contain"
                            alt={title}
                        />
                    ) : (
                        <img
                            src={background?.imageBackground?.sourceUrl}
                            className="w-full h-full object-contain"
                            alt={title}
                            lazy
                        />
                    )}
                </div>
            )}

            
                <div className="container text-white relative text-center pt-[214px] md:pt-24 pb-28 lg:pb-0 lg:pt-[114px]">
                    {title && (
                         <div className={headingStyle.heroTitle} dangerouslySetInnerHTML={{__html: title}} />
                    )}

                    {description && (
                        <p className={headingStyle.textDes}>{description}</p>
                    )}

                    {buttons && (
                        <div className="flex items-center justify-center gap-x-[34px]">
                            {buttons?.map((button, index) => {
                                const { buttonType, arrow, buttonLink } = button
                                if (!buttonLink) return null
                                return (
                                    <Button
                                        key={index}
                                        styles={toCamelCase(buttonType)}
                                        hasArrow={arrow}
                                        buttonLink={buttonLink}
                                    >
                                        {buttonLink.title}
                                    </Button>
                                )
                            })}
                        </div>
                    )}
                </div>
            
            {pageLoaded && (
                <div className="absolute bottom-[5%] hidden xs:block">
                    <div  className='flex justify-center items-center'>
                        <div onClick={scrollDown} className={headingStyle?.mouse}></div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default HeroBlock
